import { select } from '@ngneat/elf';
import {getAuditOfferDataSource, getAuditOffersDataSource, getEngagedSupplierDataSource} from './audit-offer.requests';
import { auditOfferStore } from './audit-offer.store';

export class AuditsOfferQuery {
  store = auditOfferStore;

  auditsofferList$ = getAuditOfferDataSource.data$();
  auditsoffers$ = getAuditOffersDataSource.data$();
  engagedSuppliers$ = getEngagedSupplierDataSource.data$();
  contract$ = this.store.pipe(select((state) => state.contract));


  version$ = this.store.pipe(select((state) => state.version));
  actionArray$ = this.store.pipe(select((state) => state.actionArray));
  auditsFormalizationAction$ = this.store.pipe(select((state) => state.auditsFormalizationAction));
}

export const auditsofferQuery = new AuditsOfferQuery();